var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bchip"},[_c('span',{staticClass:"bdot",style:({ background: _vm.color })}),_vm._v(_vm._s(_vm.label || _vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }